<template lang="pug">
div
  v-img(
    src="/img/header.jpg",
    gradient="to right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.1)",
    max-height="270px"
  ) 
    .h-100.w-100.d-flex.justify-center.align-center
      router-link.white--text(to="/")
        img.main-header-desktop-logo.py-1(:src="logo", contain)
  header.main-header-desktop.elevation-4.primary.darken-2
    v-container.d-flex.justify-center.align-center
      nav-menu(:menu="menu")
</template>

<script>
import NavMenu from "./NavMenu";

export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    logo() {
      return this.files + this.$rest("informations").item.img;
    },
  },
  components: {
    NavMenu,
  },
};
</script>

<style>
.main-header-desktop-logo {
  height: 200px;
  filter: drop-shadow(2px 2px 1px #333);
}
</style>
